import { normalizePackageSelection } from '@/lib/package-utils'
import { useEffect } from 'react'
import { DropdownCountry1 } from '@/components/DropdownCountry'
import DropdownPackageName, {
  usePackageName,
} from '@/components/DropdownPackage'
import AppSelect from '@/components/zthd/app-select'
import { useUrlParamsStore } from '@/stores/url-params-store'
import { usePid2 } from '@/components/DropdownPid'
import CampaignDetail from '../components/roas-analysis-view'
import { DropdownMediaGroup } from '@/components/DropdownMediaGroup'
import { RoasDatePickerTroasGate } from '../components/roas-date-picker-troas-gate'

const Roas = () => {
  const params = useUrlParamsStore((state) => state.params)
  const setParam = useUrlParamsStore((state) => state.setParam)
  const setParams = useUrlParamsStore((state) => state.setParams)
  const resetParams = useUrlParamsStore((state) => state.resetParams)

  const updatePackageName = usePackageName((state) => state.update)

  const updateSearchParams = (key, value) => {
    if (key === 'pid') {
      updatePackageName(normalizePackageSelection(value, usePackageName.getState().value))
    }
    setParam(key, value)
  }

  useEffect(() => {
    resetParams()
    setParams({
      pid: '1',
      country: 'BR',
      media_group: 'total',
    })
    updatePackageName('')
  }, [setParams, resetParams, updatePackageName])

  useEffect(() => {
    usePid2.getState().updateSingle(params.pid)
  }, [params.pid])

  useEffect(() => {
    const unsubscribe = usePackageName.subscribe((state) => {
      updateSearchParams('packageName', state.value)
    })
    return unsubscribe
  }, [updateSearchParams])

  useEffect(() => {
    // on component unmount
    return () => {
      updatePackageName('')
    }
  }, [updatePackageName])

  const countryValue = params.country === 'total' ? 'all' : params.country
  const pidValue = params.pid === 'total' ? 'all' : params.pid
  const id =
    ['14', '36'].includes(params.pid) && params.packageName && !['main', 'total'].includes(params.packageName)
      ? `${params.media_group}_${countryValue}_${pidValue}_${params.packageName}`
      : `${params.media_group}_${countryValue}_${pidValue}${params.pid === '36' && params.packageName !== 'main' ? '_packages' : ''}`

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-4">
        <AppSelect
          value={params.pid || '1'}
          onValueChange={(value) => updateSearchParams('pid', value)}
        />
        <DropdownPackageName />
        <DropdownCountry1
          value={params.country || 'BR'}
          update={(value) => updateSearchParams('country', value)}
        />
        <DropdownMediaGroup
          value={params.media_group || 'total'}
          update={(value) => updateSearchParams('media_group', value)}
        />
      </div>

      <RoasDatePickerTroasGate isTotal>
        <CampaignDetail id={id} isTotal={true} />
      </RoasDatePickerTroasGate>
    </div>
  )
}

export default Roas
